var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 1309,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1250 1301.37c690.36 0 1250-291.32 1250-650.686C2500 291.321 1940.36 0 1250 0 559.644 0 0 291.321 0 650.684c0 359.366 559.644 650.686 1250 650.686Z",
    fill: "#252B33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m351.025 1035.96 136.993-693.499h316.767c136.983 8.564 205.475 77.051 205.475 196.924 0 205.478-162.662 325.342-308.219 316.777H547.949l-34.248 179.798H351.025Zm231.163-308.216L625 470.889h111.299c59.932 0 102.734 25.683 102.734 77.05-8.554 145.557-77.051 171.241-154.101 179.805H582.188Zm396.25 128.418 136.982-693.486h162.68l-34.25 179.785h154.1c136.99 8.564 188.36 77.051 171.24 162.676l-59.93 351.025h-171.23l59.93-316.777c8.55-42.813 8.55-68.496-51.37-68.496h-128.43l-77.05 385.273H978.438Zm519.852 179.798 136.98-693.499h316.78c136.99 8.564 205.49 77.051 205.49 196.924 0 205.478-162.68 325.342-308.22 316.777h-154.11l-34.25 179.798h-162.67Zm231.15-308.216 42.82-256.855h111.3c59.94 0 102.74 25.683 102.74 77.05-8.56 145.557-77.05 171.241-154.1 179.805h-102.76Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhp);
export default __webpack_public_path__ + "static/media/php.1a1d1ecd5405a2a7593a0898b0f5380e.svg";
export { ForwardRef as ReactComponent };